import { render, staticRenderFns } from "./FilaDeAtendimento.vue?vue&type=template&id=ea798e1a&"
import script from "./FilaDeAtendimento.vue?vue&type=script&lang=js&"
export * from "./FilaDeAtendimento.vue?vue&type=script&lang=js&"
import style0 from "./FilaDeAtendimento.vue?vue&type=style&index=0&id=ea798e1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports